export { default } from './CloseDevice';
